<template>
  <div class="">
    <AuthPagesTemplate>
      <div
        lg="4"
        class="d-flex align-items-center position-relative"
      >
        <div
          class="d-flex flex-row-reverse w-100"
          style="position:absolute; top:0"
        >
          <Locale
            class="mt-1"
          />
        </div>
        <b-col
          sm="8"
          md="6"
          xl="12"
          class="px-xl-2 mx-auto mt-5  px-2 p-lg-5"
        >
          <b-card-title
            class="mb-1 text-center"
            title-tag="h2"
          >
            {{ $t('forget_password') }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('forget_password_description') }}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="submit"
            >
              <b-form-group
                :label="$t('email')"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('email')"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="form.email"
                    :state="errors.length > 0 ? false:null"
                    name="email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div class="d-flex justify-content-center">
                <b-form-group>
                  <vue-recaptcha
                    ref="recaptcha"
                    class="mt-1"
                    :sitekey="sitekey"
                    :load-recaptcha-script="true"
                    @expired="onCaptchaExpired"
                    @verify="onVerify"
                  />
                </b-form-group>
              </div>
              <b-button
                type="submit"
                variant="primary"
                block
                class="mt-2"
                :disabled="!form.recaptcha"
                pill
              >
                <span v-if="!pending">{{ $t('send_reset_link') }}</span>
                <b-spinner
                  v-else
                  small
                  type="grow"
                />
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-button
              pill
              type="submit"
              variant="dark"
              block
              :to="{name:'login'}"
            >
              {{ $t('back_to_login') }}
            </b-button>
          </p>
        </b-col>
      </div>
    </AuthPagesTemplate>
  </div>
</template>

<script>

import ForgotPassword from '@/views/logics/auth/ForgotPassword'
import AuthPagesTemplate from '../components/authPagesTemplate.vue'

export default {
  components: {
    Locale: () => import(`@/layouts/${process.env.VUE_APP_THEME_NAME}/components/Locale.vue`),
    AuthPagesTemplate,
  },
  mixins: [ForgotPassword],
}
</script>

<style lang="scss">

</style>
